import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { SkeletonRegion } from './_shared'

export interface StateTimelineSkeletonProps {
	className?: string
	label?: string | false
}

export function StateTimelineSkeleton({ className, label = 'Loading timeline' }: StateTimelineSkeletonProps) {
	return (
		<SkeletonRegion
			label={label}
			className={cn(
				'flex flex-col h-full w-full min-h-0 min-w-0 justify-center overflow-hidden px-4 bg-background',
				className,
			)}>
			{/* Timeline Segments Bar — grows with the panel instead of sitting at a fixed 120px */}
			<div className='w-full h-1/2 max-h-30 min-h-6 rounded-sm bg-accent/10 border border-border/40 flex items-center p-0.5 overflow-hidden gap-px'>
				<Skeleton className='h-full w-[8%] bg-accent/70 rounded-none' />
				<Skeleton className='h-full w-[12%] bg-accent/40 rounded-none' />
				<Skeleton className='h-full w-[5%] bg-accent/55 rounded-none' />
				<Skeleton className='h-full w-[35%] bg-accent/75 rounded-none' />
				<Skeleton className='h-full w-[18%] bg-accent/35 rounded-none' />
				<Skeleton className='h-full w-[2%] bg-accent/80 rounded-none' />
				<Skeleton className='h-full w-[20%] bg-accent/50 rounded-none' />
			</div>
		</SkeletonRegion>
	)
}
